import { Outlet } from 'react-router-dom';

export const IndexLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
